import UnknownError from 'pages/unknownError/UnknownError'
import { Component } from 'react'

interface Props {
    children: React.ReactNode
}

interface State {
    hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true }
    }

    componentDidCatch() {
        // You can log the error or handle it in other ways
        this.setState({ hasError: true })
    }

    render() {
        if (this.state.hasError) {
            return <UnknownError />
        }
        return this.props.children
    }
}

export default ErrorBoundary
